import Swiper from 'swiper/bundle';

// init swiper for page
function initializePage() {
    new Swiper('.recipes-carousel .swiper', {
        spaceBetween: 16,
        loop: true,
        slidesPerView: 2,
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
    });
}

initializePage();
